import React, { useContext, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../../images/logo.png';
import { AuthContext } from '../AuthContext';
import LoadingComponent from '../../utils/LoadingComponent';
import Swal from 'sweetalert2';
import MyWebsite from '../../utils/MyWebsite';

const forestGreen = '#228B22';

const ForgotPassword = () => {
  const {resetPasswordRequest} = useContext(AuthContext)
  const [formData, setFormData] = useState({ email: '',website:'' });
  const [message, setMessage] = useState('');
  const [loading, setLoading]= useState(false)
  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.website) {
          setMessage('Bot-like behavior detected.');
          setLoading(false);
          return;
        }
    setLoading(true)
    const response = await resetPasswordRequest(formData);
    if (response?.status === 'success'){
    // Optional: Show feedback to the user
  Swal.fire({
    title: 'Success!',
    text: 'Password recovery instructions sent. Redirecting in 10 seconds...',
    icon: 'success',
    timer: 10000,
    timerProgressBar: true,
    showConfirmButton: false,
  });

  // Delay navigation for 10 seconds
  setTimeout(() => {
    navigate(`/login?em=${formData?.email}`);
  }, 10000); // 10,000 ms = 10 seconds
  }

  setMessage(response?.message);
  setLoading(false)
  };

  if(!!loading) return <LoadingComponent loadingText={'Sending Recovery email ...'}/>

  return (
    <motion.div
      className="d-flex justify-content-center align-items-center vh-100"
      // style={{ background: '#f8f9fa' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.div
        className="card p-4 m-3 shadow-lg"
        style={{
          width: '100%',
          maxWidth: '480px',
          borderRadius: '16px',
          border: `1px solid ${forestGreen}`,
          backgroundColor: 'rgb(225,225,225,0.5)',
        }}
        initial={{ y: 30, scale: 0.98 }}
        animate={{ y: 0, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        {/* Logo */}
        <div className="text-center mb-3">
          <img
            src={logo}
            alt="App Logo"
            style={{ width: '150px', height: 'auto' }}
          />
        </div>

        <h3
          className="text-center mb-4"
          style={{ color: 'darkgreen', fontWeight: '600', fontSize: '1.8rem' }}
        >
          Forgot Password?
        </h3>

        {message && (
          <div className="alert alert-info text-center">{message}</div>
        )}

        <form onSubmit={handleSubmit}>
          <MyWebsite onChange={handleChange} />
          {/* Name */}
          {/* <motion.div className="form-group mb-3" whileFocus={{ scale: 1.02 }}>
            <label style={{ fontWeight: 500, color: '#333' }}>👤 Name</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
              style={{ borderColor: forestGreen }}
            />
          </motion.div> */}

          {/* Email */}
          <motion.div className="form-group mb-4" whileFocus={{ scale: 1.02 }}>
            <label style={{ fontWeight: 500, color: '#333' }}>✉️ Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
              style={{ borderColor: forestGreen }}
              placeholder='Enter Your Email Address'
            />
          </motion.div>

          {/* Submit */}
          <motion.button
            type="submit"
            className="btn w-100"
            style={{
              backgroundColor: forestGreen,
              color: '#fff',
              fontWeight: 600,
              letterSpacing: 0.5,
              borderRadius: '8px',
            }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            disabled={message}
          >
            Send Recovery Email
          </motion.button>
        </form>

        {/* Back to Login Link */}
        <div className="text-center mt-4">
          <Link to="/login" style={{ color: forestGreen, fontWeight: 500 }}>
            <FaArrowLeft className="me-2" />
            Back to Login
          </Link>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ForgotPassword;
